/**
 * A fresh id for a staged prop, minted only on the persisting path.
 *
 * Shared by the `style_room_decor` tool and the browser's Add accessories,
 * so both write ids of one shape. The GLOBAL `crypto` is read behind a guard
 * rather than `require('crypto')`: the web bundle (CRA 5 / webpack 5) has no
 * Node polyfill, and web jest's jsdom has no `crypto` at all.
 * `getRandomValues` covers a page served over plain http on a LAN IP, where
 * `randomUUID` is withheld (it needs a secure context).
 */

function randomHex() {
  if (typeof crypto !== 'undefined') {
    if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    if (typeof crypto.getRandomValues === 'function') {
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
    }
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

function freshStagingId() {
  return `staging-obj-${randomHex()}`;
}

module.exports = { freshStagingId };
